/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-17T17:39:58.443
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportMonthRentContractUndue,
	listReportMonthRentContractUndueInit,
	listReportMonthRentContractUndueByAuthorizations,
	deleteReportMonthRentContractUndue
	
} from '@api/report/ReportMonthRentContractUndue';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportMonthRentContractUndue({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentContractUndue(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportMonthRentContractUndueByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentContractUndueByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportMonthRentContractUndueInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentContractUndueInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportMonthRentContractUndue({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportMonthRentContractUndue({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
